import { define } from '../Decoder.mjs'

export var anyNumber = define(function (blob, ok, err) {
  return typeof blob === 'number' ? ok(blob) : err('Must be number')
})

export var number = anyNumber.refine(function (n) {
  return Number.isFinite(n)
}, 'Number must be finite')

export var integer = number.refine(function (n) {
  return Number.isInteger(n)
}, 'Number must be an integer')

export var positiveNumber = number.refine(function (n) {
  return n >= 0
}, 'Number must be positive')

export var positiveInteger = integer.refine(function (n) {
  return n >= 0
}, 'Number must be positive')
